import { PartnerType } from 'vopay';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { usePermissions } from '@/providers/Permissions.provider';

/**
 * Whether creating an account will actually send the onboarding application form to the primary
 * contact. The backend forces the email off for Technology partners and for VARs carrying
 * reporting liability, and refuses it without onboarding-form access — so copy promising the email
 * (the contact-email tooltip, the review note) only shows when it will really send.
 *
 * `partnerAccountType` is the type of the partner account the account is created under, when that
 * is not the session's (the partner page's Add Account); its other flags are inherited from the
 * session's.
 */
export default function useWillSendOnboardingEmail(partnerAccountType?: PartnerType): boolean {
  const { permissions } = usePermissions();

  const {
    response: { partnerType: sessionPartnerType },
  } = usePartnerLogin();

  const partnerType = partnerAccountType ?? sessionPartnerType;

  return (
    permissions.accountOnboardingFormAccess &&
    partnerType !== 'Technology' &&
    !(partnerType === 'VAR' && permissions.partnerLiability)
  );
}
